import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { isotipoApp } from '../utils/assets';

// Isotipo de la app; si no hay imagen para ese código, ícono genérico
export default function LogoApp({ codigo, activa = true, tam = 'w-12 h-12' }) {
  const [sinLogo, setSinLogo] = useState(false);
  return (
    <div className={`${tam} shrink-0 rounded-xl flex items-center justify-center overflow-hidden ${
      sinLogo ? (activa ? 'bg-blue-600 text-white shadow-md shadow-blue-500/20' : 'bg-gray-100 dark:bg-gray-700 text-gray-400') : 'bg-gray-50 dark:bg-gray-900/60 border border-gray-100 dark:border-gray-700'
    }`}>
      {sinLogo ? (
        <Shield className="w-5 h-5" />
      ) : (
        <img src={isotipoApp(codigo)} alt="" onError={() => setSinLogo(true)} className={`w-[80%] h-[80%] object-contain ${activa ? '' : 'grayscale opacity-60'}`} />
      )}
    </div>
  );
}
